var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorCircleRedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: 800.00964,
    width: 799.99811,
    id: "Capa_1",
    viewBox: "0 0 51.975877 51.976627",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "translate(-0.99828414,-0.52844399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 45.371409,8.1315697 c -10.137,-10.1370002 -26.632,-10.1380002 -36.7699999,0 -10.138,10.1380003 -10.137,26.6320003 0,36.7700003 10.1369999,10.138 26.6319999,10.138 36.7699999,0 10.137,-10.138 10.137,-26.633 0,-36.7700003 z",
    id: "path1",
    style: {
      fill: "#ffd5d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.239409,36.76957 c -0.781,0.781 -2.047,0.781 -2.828,0 l -7.425,-7.425 -7.778,7.778 c -0.781,0.781 -2.047,0.781 -2.828,0 -0.781,-0.781 -0.781,-2.047 0,-2.828 l 7.778,-7.778 -7.425,-7.425 c -0.781,-0.781 -0.781,-2.048 0,-2.828 0.781,-0.781 2.047,-0.781 2.828,0 l 7.425,7.425 7.071,-7.071 c 0.781,-0.781 2.047,-0.781 2.828,0 0.781,0.781 0.781,2.047 0,2.828 l -7.071,7.071 7.425,7.425 c 0.781,0.781 0.781,2.047 0,2.828 z",
    id: "path2",
    style: {
      fill: "#ff0000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircleRedIcon);
export default __webpack_public_path__ + "static/media/error_circle_red_icon.1313497ccdd97a4602258da44eba5490.svg";
export { ForwardRef as ReactComponent };